import { render, staticRenderFns } from "./despatch-order-list.vue?vue&type=template&id=47f761b7&"
import script from "./despatch-order-list.vue?vue&type=script&lang=js&"
export * from "./despatch-order-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports